import Vue from 'vue'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
  var options = {
          region: 'BRA',
          resolution: 'provinces',
          width: 556,
          height: 347,
          displayMode: 'text',
          mapsApiKey: 'AIzaSyCpw7lioraxBNkr26fcBCpbWTquBK9aOnE'
      };
Chartkick.configure({
	language: "pt",
	region:'BRA',
	resolution: 'provinces',
	displayMode: 'text',
	width: 556,
    height: 347,
    options,
    mapsApiKey: 'AIzaSyCpw7lioraxBNkr26fcBCpbWTquBK9aOnE'
})

Vue.use(Chartkick.use(Chart))